export const vpnKeys = {
	all: ["vpn"] as const,
	key: (userId: number) => [...vpnKeys.all, "key", userId] as const,
}
